<template>
<div class="anthemBG" >
  <div id="nav">
      <router-link to="/leaderboard">Leaderboard</router-link> |
      <router-link to="/global">Global List</router-link> 
    </div>
    <div  style="height:70px;"></div>
  <div class="panel " style="width:800px;max-width:100%;margin:auto;transform:scale(1);" >
     <div class="panelTop">
      
      <div class="status " style="margin-bottom:10px;">
          <div class="title2">Controls:</div>
          <div class="flexPad"></div>
          <StatusBtn @click.native="pauseGame" :label="'PAUSE'" :colour="'#f0f'" ></StatusBtn>
          <StatusBtn @click.native="restartGame" :label="'UNPAUSE'" :colour="'#07f'" ></StatusBtn>
          <StatusBtn @click.native="resetDB" :label="'RESET'"  :colour="'#073'"></StatusBtn>    
      </div>
      <div class="status ">
        <div class="title2">Game State:</div>
        <StatusLight :label="gameState" :status="'none'"  style="font-size:1.5em;"></StatusLight>
        <div class="flexPad"></div>
        <StatusLight :label="'OSC'" :status="connectionOSC" ></StatusLight>
        <StatusLight  :label="'WEB'" :status="connectionWEB" ></StatusLight>
        <StatusLight v-if="false" @click.native="resetDB" :label="'RESET'" :status="false" style="cursor:pointer;"></StatusLight>
      </div>
       <div class="status ">
      <div class="title2">Player Entry:</div>
      </div>
      </div>
      <div class="flexPad"></div>
        <div>
          <div class="details">
            <TextInput style="z-index:5;" @validate="validate"  :field="'Location'" :items="locations" :showAdd="true" :doAdd="addLocation" :validation="['notEmpty','inList']" />
            <TextInput style="z-index:4;" @validate="validate" ref="nameF" :field="'Name'" :items="names" :allowOverride="true" :validation="['notEmpty','unique']"/>
            <!--TextInput @validate="validate" ref="postcodeF" :field="'Postcode'" :validation="['notEmpty']"/-->
            <Select @validate="validate" ref="difficultyF" :field="'Difficulty'" :items="levels" :validation="['notEmpty','inList']"></Select>
            <div @click="triggerBallIn" class="ballInBtn">Ball IN</div>
          </div>
          <div v-if="allValid && gameState=='Waiting'" @click="activateTable" class="pillBtn" style="width:200px; margin-top:20px;">Send Player</div>  
        </div>
        <div class="flexPad"></div>
        <div class="panelBase consolePanelBase"></div>
      </div>
      <div class="anthemIcon"></div>
    </div>
</template>

<script>
// @ is an alias to /src
import TextInput from '@/components/TextInput.vue'
import Select from '@/components/Select.vue'
import StatusLight from '@/components/StatusLight.vue'
import StatusBtn from '@/components/StatusBtn.vue'


export default {
  name: 'Home',
  components: {
    TextInput,Select,StatusLight,StatusBtn
  },
  data() {
      return {
        NameValue:null,
        LocationValue:false,
        PostcodeValue:false,
        DifficultyValue:false,
      }
  },
  mounted(){
   console.log(this.locations)
    
  },
  computed:{
    connectionWEB(){
      return this.$store.getters.getConnectionWEB
    },
    connectionOSC(){
      return this.$store.getters.getConnectionOSC
    },
    gameState(){
      return this.$store.getters.getGameState
    },
    levels(){
      return this.$store.getters.getLevels
    },
    
    player(){
      let player={}
      player.Name=this.NameValue
      player.Location=this.LocationValue
      player.Postcode=this.PostcodeValue
      player.Difficulty=this.DifficultyValue
      player.DifficultyIndex=this.difficultyIndex
      
      return player
    },
    allValid(){
      return this.NameValue && this.LocationValue && this.DifficultyValue
    },
    names(){
      return this.$store.getters.getNames || ["xxx"] 
    },
    locations(){
      return this.$store.getters.getLocations || ["xxx"]
    },
    difficultyIndex(){
      let di=-1
      if(this.levels){
      for(var d in this.levels){
        if (this.levels[d] == this.DifficultyValue){
          di =d
        }
      }
      }
      return di
    }
    
  },
  methods:{
    
   
    validate(val,field){
      if(val){
         this[field+"Value"]= val
      }else{
         this[field+"Value"]= val
      }
      
    
    },
    addLocation(loc){
      console.log("CLICK LOC",loc)
      
      this.$store.dispatch("addLocation",loc)
    },
    triggerBallIn(){
      this.$store.dispatch("triggerBallIn")
    },
   
    activateTable(){
      console.log("SEND",this.player)
      
      this.$store.dispatch("addPlayer",this.player)
      this.$store.dispatch('setDifficulty',this.difficultyIndex)
      this.$store.dispatch("setGameState","Ready")
      this.$store.dispatch("setButtonState","Active")
      this.$refs.nameF.clearField()
      this.$refs.postcodeF.clearField()
      this.$refs.difficultyF.clearField()
    },
    resetDB(){
 
      this.$store.dispatch("setGameState","Waiting")
      this.$store.dispatch("setButtonState","Locked")
    },
    pauseGame(){
      this.$store.dispatch("setGameState","Paused")
    },
    restartGame(){
      this.$store.dispatch("setGameState","Replay")
    },
    doStandby(){
      this.$store.dispatch("setGameState","Standby")
    }
  }
}

</script>
<style >
.status{
  display:flex;
  font-size:1.5em;
  flex-wrap: wrap;
}

.details{
  font-size:30px;
  color:#000;
}
.ballInBtn{
  width: 50%;
  max-width: 210px;
  margin: 40px auto 0;
  padding: 14px 16px;
  border-radius: 10px;
  background: #073;
  color: #fff;
  font-size: 1.15em;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  cursor: pointer;
  user-select: none;
}
.ballInBtn:hover{
  filter: brightness(1.08);
}
.consolePanelBase{
  padding-top: 20px;
  padding-bottom: 20px;
}
  .fieldName{
    min-width:200px;
    text-align:right;
    color: #fff;
  }
  
  .btn{
    cursor:pointer;
    width:40px;
    border:solid #000 1px;
    border-radius:3px;
    margin:0px 5px;

  }
  .bumpRight{
    margin-left:130px;
  }
</style>
